'use strict';

function AdminController(adminUserService, userService, $modal, $route) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.toggleUsers = toggleUsers;
  vm.toggleUserActive = toggleUserActive;
  vm.isActiveFilter = isActiveFilter;
  vm.isToggling = isToggling;

  vm.openDeleteUserModal = openDeleteUserModal;
  vm.deleteUser = deleteUser;

  vm._isFinishedToggling = _isFinishedToggling;
  vm._isNoLongerToggling = _isNoLongerToggling;

  function $onInit() {
    vm.users = [];
    vm.active = false;
    vm.toggling = [];
    vm.userFilterText = '';

    adminUserService.list().then(function(response) {
      vm.users = response.data;
      vm.toggleUsers();
    });
  }

  function toggleUsers() {
    vm.active = !vm.active;
    vm.userFilterText = '';
  }

  function toggleUserActive(user) {
    vm.toggling.push(user.id);
    adminUserService.patch(user.id, { 'is_active': !user['is_active'] })
      .then(vm._isFinishedToggling(user))
      .finally(vm._isNoLongerToggling(user));
  }

  function isActiveFilter(active) {
    return function filterFor(user) {
      return user['is_active'] === active;
    };
  }

  function isToggling(user) {
    return vm.toggling.indexOf(user.id) === -1;
  }

  function openDeleteUserModal(user) {
    vm.user = user;
    vm.deleteUserModal = $modal({
      template: require('./users-delete.modal.html'),
      show: true
    });
    vm.deleteUserModal.$scope.submit = deleteUser;
  }

  function deleteUser() {
    userService.get(vm.user.id).then(function (user) {
      user.first_name = 'Borttagen';
      user.last_name = 'Användare';
      user.is_active = false;
      userService.update(user.id, user).then($route.reload()).finally(
        vm.deleteUserModal.$scope.$hide()
      );
    });
  }

  function _isFinishedToggling(user) {
    return function(response) {
      vm.users[vm.users.indexOf(user)]['is_active'] = response.data.is_active;
    };
  }

  function _isNoLongerToggling(user) {
    return function() {
      vm.toggling.splice(vm.toggling.indexOf(user.id), 1);
    };
  }
}

module.exports = AdminController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/users/users.controller.js
 ** module id = 143
 ** module chunks = 0
 **/